import React from "react";
import { MoreHorizontalRegular } from "@fluentui/react-icons";
import styles from "./ChatHistoryListItemCell.module.css";

export type ChatHistoryListItemCellProps = {
  trailId: string;
  title: string;
  selected: boolean;
  menuOpen: boolean;
  onSelect: () => void;
  onOpenMenu: (rect: DOMRect) => void;
  menuTargetRef?: React.RefObject<HTMLDivElement>;
};

export function ChatHistoryListItemCell({
  trailId,
  title,
  selected,
  menuOpen,
  onSelect,
  onOpenMenu,
  menuTargetRef,
}: ChatHistoryListItemCellProps) {
  const [hovered, setHovered] = React.useState(false);
  const showEllipsis = hovered || selected || menuOpen;

  return (
    <div
      className={`${styles.itemCell} ${selected ? styles.selected : ""}`}
      onClick={onSelect}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect();
        }
      }}
      data-testid={`console-history-open-${trailId}`}
    >
      <div className={styles.chatRow}>
        <div className={styles.chatTitle} data-testid="console-history-row">
          {title}
        </div>
        {showEllipsis ? (
          <div
            ref={menuTargetRef}
            className={styles.menuButtonContainer}
            onClick={(event) => {
              event.stopPropagation();
              onOpenMenu((event.currentTarget as HTMLElement).getBoundingClientRect());
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.stopPropagation();
                onOpenMenu((event.currentTarget as HTMLElement).getBoundingClientRect());
              }
            }}
            aria-label="Conversation options"
          >
            <MoreHorizontalRegular className={styles.itemButton} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
